export default "__VITE_ASSET__Dbv$nu4J__"